import { render, staticRenderFns } from "./Rip.vue?vue&type=template&id=297b46b1&"
import script from "./Rip.vue?vue&type=script&lang=ts&"
export * from "./Rip.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports